import {
  GET_APP_VERSION,
  GET_APP_VERSION_SUCCESS,
  GET_APP_VERSION_FAIL,
  UPDATE_APP_VERSION,
  UPDATE_APP_VERSION_SUCCESS,
  UPDATE_APP_VERSION_FAIL,
  UPDATE_APP_VERSION_RESET,
} from '../actions/settingAction';

const initialState = {
  getAppVersionState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateAppVersionState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APP_VERSION:
      return {
        ...state,
        getAppVersionState: { ...state.getAppVersionState, apiState: 'loading' },
      };
    case GET_APP_VERSION_SUCCESS:
      return {
        ...state,
        getAppVersionState: {
          apiState: 'success',
          data: action.response.data,
          message: action.response.message || 'Version retrieved',
          errors: null,
          error: null,
        },
      };
    case GET_APP_VERSION_FAIL:
      return {
        ...state,
        getAppVersionState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to fetch version',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };

    case UPDATE_APP_VERSION:
      return {
        ...state,
        updateAppVersionState: { ...state.updateAppVersionState, apiState: 'loading' },
      };
    case UPDATE_APP_VERSION_SUCCESS:
      return {
        ...state,
        updateAppVersionState: {
          apiState: 'success',
          data: action.response.data,
          message: action.response.message || 'Version updated',
          errors: null,
          error: null,
        },
        // Also update getAppVersionState so sidebar reflects immediately
        getAppVersionState: {
          ...state.getAppVersionState,
          data: action.response.data,
        },
      };
    case UPDATE_APP_VERSION_FAIL:
      return {
        ...state,
        updateAppVersionState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to update version',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_APP_VERSION_RESET:
      return {
        ...state,
        updateAppVersionState: initialState.updateAppVersionState,
      };

    default:
      return state;
  }
};

export default settingReducer;
